const component = "searchable-select-section-simple-tree";

export const searchableSelectSectionSimpleTree = {
  component,
  searchTextInput: `${component}/search-text-input`,
  skeleton: `${component}/skeleton`,
} as const;
